import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import store from './redux/store';
import { AuthProvider } from './contexts/AuthContext';
import { LocalizationProvider } from './contexts/LocalizationContext';

import './scss/index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <StrictMode>
  <ErrorBoundary>
    <HelmetProvider>
      <BrowserRouter>
        <ReduxProvider store={store}>
          <AuthProvider>
            <LocalizationProvider>
              <App />
            </LocalizationProvider>
          </AuthProvider>
        </ReduxProvider>
      </BrowserRouter>
    </HelmetProvider>
  </ErrorBoundary>
  // </StrictMode>
);
